module.exports = __webpack_public_path__ + "img/geofisica2_4-3.c0ee4de0.jpg";